import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import User from "../../../types/User"


export interface componentProps {
    item: User
}

const ViewItemGroupAccount: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('accounts.title_item')}</IonItemDivider>
            <IonItem lines="full">
                <IonLabel>{t('accounts.form.name')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.account?.name || '-'}</IonNote>
            </IonItem>
            {item.account && item.account.counts &&
            <IonItem lines="full">
                <IonLabel>{t('users.users_from_max')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.x_of_y', {
                        x: ((item.counts?.users || 0) + (item.counts?.usersReserved || 0)) || '-',
                        y: item.maxUsers || '?'
                    })}
                    {item.account.counts.usersReserved > 0 &&
                        <span> ({t('common.reserved')} {item.account?.counts?.usersReserved})</span>
                    }
                </IonNote>
            </IonItem>
            }
        </IonItemGroup>
    )
}

export default ViewItemGroupAccount